import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box, Button, Stack, Typography } from "@mui/material";

import useData from "../../hooks/useData";
import useLocalization from "../../hooks/useLocalization";
import usePage from "../../hooks/usePage";

import Page from "./Page";
import Card from "../layout/Card";

const Exports = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { getFromServer, addToWorkQueue } = useData();
  const { getTitle } = useLocalization();
  const { showMessage } = usePage();

  const [data, setData] = useState(null);
  const [entityName, setEntityName] = useState();
  const [entityId, setEntityId] = useState();
  const [clientId, setClientId] = useState();

  useEffect(() => {
    setEntityId(location.state.entityId);
    setEntityName(location.state.entityName);
    setClientId(location.state.clientId);
  }, []);

  useEffect(() => {
    getData();
  }, [entityId]);

  const getData = async () => {
    if (!entityId) {
      setData(null);
      return;
    }

    const results = await getFromServer({ entityName, id: entityId });
    if (results) {
      setData(results);
    } else {
      setData(null);
    }
  };

  const handleToolbarClick = async (name) => {
    switch (name) {
      case "project":
        navigate("/project", { state: { projectId: entityId, clientId } });
        break;
    }
  };

  const handleImportSelection = async (type) => {
    await addToWorkQueue("exportLocationsFromProject", {
      entityName,
      entityId,
    });

    showMessage("Your file will be emailed to you shortly.");
  };

  return (
    <>
      <Page
        pageName={getTitle("exports")}
        entityName={data?.name}
        includeToolbar
        items={[{ name: "project", iconName: "Lan" }]}
        onToolItemClick={handleToolbarClick}
      >
        <Box
          display="flex"
          gap={1}
        >
          <Card
            title={getTitle("Exports")}
            sx={{ width: "300px" }}
          >
            <Stack spacing={1}>
              <Box>
                <Button
                  sie="small"
                  onClick={() => handleImportSelection("locations")}
                >
                  Locations
                </Button>
              </Box>
            </Stack>
          </Card>
        </Box>
      </Page>
    </>
  );
};

export default Exports;
